import React, { useState } from 'react';
// import MetalView from './Views/MetalView';
// import PolymerView from './Views/PolymerView';
import { useAccess, useSetAccess } from 'state/hooks.js';
import { useHistory } from 'react-router-dom';
// import TooltipTrippy from "app/components/ProductionScenario/TooltipTrippy";
import { CALCULATOR_TYPE } from '../ConditionalEnums';


const CustomModal = ({ typeModal, btnTitle, techData,isOpen,setIsOpen ,setSelectedType}) => {
  let Access = useAccess();
  // const [isOpen, setIsOpen] = useState(false);
  const [key, setKey] = useState(false);
  const history = useHistory();

  // const openModal = () => {
  //   setIsOpen(true);
  // };



  const renderPolymer = () => {
    return techData.map((technology) => {
      return (
        <React.Fragment key={technology.user_group_step_access_id}>
          {technology.technology_id.name === "Polymer" && (
            <>
              <div
                className="cmodal_body_layout cursor-pointer"
                onClick={async () => {
                  technology.technology_id.name === "Polymer" &&
                    setKey("select1");

                  sessionStorage.setItem(
                    "calculatorType",
                    CALCULATOR_TYPE.COST
                  );
                  sessionStorage.removeItem("co2TotalToday");
                  sessionStorage.setItem("technology_type", "Estimation");

                  //as to display both graph VA Screen
                  sessionStorage.setItem(
                    "technologyName",
                    // technology.technology_id.name + " (Estimation)"
                    technology.technology_id.name + " (Simulation)"
                  );
                  sessionStorage.setItem("technologyNameForVA", technology.technology_id.name + " (Estimation)");

                  sessionStorage.setItem(
                    "technology",
                    technology.technology_id.name
                  );
                  sessionStorage.setItem("stepTypeId", 1);

                  if (key !== "") {
                    window.location.href = `/calculator/process`;
                  }
                }}
              >
                <div className="d-flex flex-column justify-content-between h-100">
                  <div className="d-flex flex-column gap-8">
                    <p
                      className={
                        "cmodal_body_title " +
                        (key === "select1" &&
                          technology.technology_id.name === "Polymer" &&
                          " type-selected")
                      }
                    >
                      {/* {technology.technology_id.name === 'Polymer' && (
                    <img
                      src="/assets/polymer.png"
                      width="25"
                      height="25"
                      alt=""
                    />
                  )} */}
                      Simple Part Cost Estimation
                    </p>
                    <div className="cmodal_body_subtitle_container">
                      <span className="cmodal_body_subtitle">
                        Cost Estimation
                      </span>
                    </div>
                  </div>
                  <p className="font-14 font-weight-normal">
                    For estimation you do not need any external softwares.
                    Estimations can provide with a +-20% accuracy cost per part
                    details.
                  </p>
                </div>
              </div>
              <>
                {Access ? (
                  <div
                    className="cmodal_body_layout cursor-pointer"
                    onClick={async () => {
                      sessionStorage.setItem(
                        "calculatorType",
                        CALCULATOR_TYPE.FULL_SIMULATION
                      );
                      sessionStorage.removeItem("co2TotalToday");

                      sessionStorage.setItem("technology_type", "Simulation");

                      technology.technology_id.name === "Polymer" &&
                        setKey("select2");
                      sessionStorage.setItem(
                        "technologyName",
                        technology.technology_id.name + " (Simulation)"
                      );
                      sessionStorage.setItem("technologyNameForVA", technology.technology_id.name + " (Simulation)");
                      sessionStorage.setItem(
                        "technology",
                        technology.technology_id.name
                      );
                      sessionStorage.setItem("stepTypeId", 2);

                      if (key !== "") {
                        window.location.href = `/calculator/process`;
                      }
                    }}
                  >
                    <div className="d-flex flex-column justify-content-between h-100">
                      <div className="d-flex flex-column gap-8">
                        <p
                          className={
                            "cmodal_body_title " +
                            (key === "select2" &&
                              technology.technology_id.name === "Polymer" &&
                              " type-selected")
                          }
                        >
                          {/* {technology.technology_id.name === 'Polymer' && (
                          <img
                          src="/assets/polymer.png"
                          width="25"
                          height="25"
                          alt=""
                          />
                          )} */}
                          Detailed Part Cost Calculation
                        </p>
                        <div className="cmodal_body_subtitle_container">
                          <span className="cmodal_body_subtitle">
                            Cost Calculation
                          </span>
                        </div>
                      </div>
                      <p className="font-14 font-weight-normal">
                        Full Estimation provides a combined analysis on cost per
                        part and carbon calculation with an accuracy of upto
                        +-5%. You would need access to  <span className="font-weight-bold"> EOSPrint/PSW </span> to use this
                        tab to its full potential.
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="cmodal_body_layout">
                    <div className="d-flex flex-column justify-content-between h-100">
                      <div
                        className="freemium-bg d-flex flex-column gap-8"
                        onClick={() => {}}
                      >
                        <a href="/premium-request" className="premium">
                          Premium
                        </a>
                        <p
                          className={
                            "cmodal_body_title " +
                            (key === "select2" &&
                              technology.technology_id.name === "Polymer" &&
                              " type-selected")
                          }
                        >
                          {/* {technology.technology_id.name === 'Polymer' && (
                        <img
                          src="/assets/polymer.png"
                          width="25"
                          height="25"
                          alt=""
                        />
                      )} */}
                          {technology.technology_id.name} (Simulation)
                        </p>
                        <div className="cmodal_body_subtitle_container">
                          <span className="cmodal_body_subtitle">
                            Cost Estimate
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
              <div
                className="cmodal_body_layout cursor-pointer"
                onClick={() => {
                  sessionStorage.setItem(
                    "calculatorType",
                    CALCULATOR_TYPE.CARBON
                  );
                  history.push("/carboncalculator/polymer-steps");
                }}
              >
                <div className="d-flex flex-column justify-content-between h-100">
                  <div className="d-flex flex-column gap-8">
                    <p className="cmodal_body_title">
                      Estimation of Carbon Footprint
                    </p>
                    <div className="cmodal_body_subtitle_container">
                      <span className="cmodal_body_subtitle">
                        Carbon Estimation
                      </span>
                    </div>
                  </div>
                  <p className="font-14 font-weight-normal">
                    In order to calculate the footprint of the application, you
                    can use this tab. For inputs, you would need access to
                    <span className="font-weight-bold"> EOSPrint/PSW </span>. This tab does not cover details on cost per
                    part.
                  </p>
                </div>
              </div>
            </>
          )}
        </React.Fragment>
      );
    });
  };

  const renderMetal = () => {
    return techData.map((technology) => {
      return (
        <React.Fragment key={technology.user_group_step_access_id}>
          {technology.technology_id.name === "Metal" && (
            <>
              <div
                className="cmodal_body_layout cursor-pointer"
                onClick={async () => {
                  technology.technology_id.name === "Metal" &&
                    setKey("select3");

                  sessionStorage.setItem(
                    "calculatorType",
                    CALCULATOR_TYPE.COST
                  );
                  sessionStorage.removeItem("co2TotalToday");
                  sessionStorage.setItem("technology_type", "Estimation");
                   //as to display both graph VA Screen

                  sessionStorage.setItem(
                    "technologyName",
                    // technology.technology_id.name + " (Estimation)"
                    technology.technology_id.name + " (Simulation)"
                  );
                  sessionStorage.setItem("technologyNameForVA", technology.technology_id.name + " (Estimation)");
                  sessionStorage.setItem(
                    "technology",
                    technology.technology_id.name
                  );
                  sessionStorage.setItem("stepTypeId", 1);

                  if (key !== "") {
                    window.location.href = `/calculator/process`;
                  }
                }}
              >
                <div className="d-flex flex-column justify-content-between h-100">
                  <div className="d-flex flex-column gap-8">
                    <p
                      className={
                        "cmodal_body_title " +
                        (key === "select3" &&
                          technology.technology_id.name === "Metal" &&
                          " type-selected")
                      }
                    >
                      {/* {technology.technology_id.name === 'Metal' && (
                    <img src="/assets/metal.png" width="25" height="25" alt="" />
                  )} */}
                      Simple Part Cost Estimation
                    </p>
                    <div className="cmodal_body_subtitle_container">
                      <span className="cmodal_body_subtitle">
                        Cost Estimation
                      </span>
                    </div>
                  </div>
                  <p className="font-14 font-weight-normal">
                    {" "}
                    For estimation you do not need any external softwares.
                    Estimations can provide with a +-20% accuracy cost per part
                    details.
                  </p>
                </div>
              </div>

              <>
                {Access ? (
                  <div
                    className="cmodal_body_layout"
                    onClick={async () => {
                      sessionStorage.setItem(
                        "calculatorType",
                        CALCULATOR_TYPE.FULL_SIMULATION
                      );
                      technology.technology_id.name === "Metal" &&
                        setKey("select4");
                      sessionStorage.setItem(
                        "technologyName",
                        technology.technology_id.name + " (Simulation)"
                      );
                      sessionStorage.setItem("technologyNameForVA", technology.technology_id.name + " (Simulation)");
                      sessionStorage.removeItem("co2TotalToday");
                      sessionStorage.setItem("technology_type", "Simulation");
                      sessionStorage.setItem(
                        "technology",
                        technology.technology_id.name
                      );
                      sessionStorage.setItem("stepTypeId", 2);

                      if (key !== "") {
                        window.location.href = `/calculator/process`;
                      }
                    }}
                  >
                    <div className="d-flex flex-column justify-content-between h-100">
                      <div className="d-flex flex-column gap-8">
                        <p
                          className={
                            "cmodal_body_title " +
                            (key === "select4" &&
                              technology.technology_id.name === "Metal" &&
                              " type-selected")
                          }
                        >
                          {/* {technology.technology_id.name === 'Metal' && (
                      <img
                        src="/assets/metal.png"
                        width="25"
                        height="25"
                        alt=""
                      />
                    )} */}
                          Detailed Part Cost Calculation
                        </p>
                        <div className="cmodal_body_subtitle_container">
                          <span className="cmodal_body_subtitle">
                          Cost Calculation
                          </span>
                        </div>
                      </div>
                      <p className="font-14 font-weight-normal">
                        Full Estimation provides a combined analysis on cost per
                        part and carbon calculation with an accuracy of upto
                        +-5%. You would need access to{" "}
                        <span className="font-weight-bold"> EOSPrint/PSW </span>{" "}
                        to use this tab to its full potential.
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="cmodal_body_layout">
                    <div className="d-flex flex-column justify-content-between h-100">
                      <div
                        className="freemium-bg d-flex flex-column gap-8"
                        onClick={() => {}}
                      >
                        <a href="/premium-request" className="premium">
                          Premium
                        </a>
                        <p
                          className={
                            "cmodal_body_title " +
                            (key === "select4" &&
                              technology.technology_id.name === "Metal" &&
                              " type-selected")
                          }
                        >
                          {/* {technology.technology_id.name === 'Metal' && (
                        <img
                          src="/assets/metal.png"
                          width="25"
                          height="25"
                          alt=""
                        />
                      )} */}
                          {technology.technology_id.name} (Simulation)
                        </p>
                        <div className="cmodal_body_subtitle_container">
                          <span className="cmodal_body_subtitle">
                            Cost Estimate
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>

              <div
                className="cmodal_body_layout cursor-pointer"
                onClick={() => {
                  sessionStorage.setItem(
                    "calculatorType",
                    CALCULATOR_TYPE.CARBON
                  );
                  history.push("/carboncalculator/metal-steps");
                }}
              >
                <div className="d-flex flex-column justify-content-between h-100">
                  <div className="d-flex flex-column gap-8">
                    <p className="cmodal_body_title">
                      Estimation of Carbon Footprint
                    </p>
                    <div className="cmodal_body_subtitle_container">
                      <span className="cmodal_body_subtitle">
                        Carbon Estimation
                      </span>
                    </div>
                  </div>
                  <p className="font-14 font-weight-normal">
                    In order to calculate the footprint of the application, you
                    can use this tab. For inputs, you would need access to{" "}
                    <span className="font-weight-bold"> EOSPrint/PSW </span>.
                    This tab does not cover details on cost per part.
                  </p>
                </div>
              </div>
            </>
          )}
        </React.Fragment>
      );
    });
  };

  return (
    // <>
    //   <p
    //     className="font-16 font-semi-bold cursor-pointer"
    //     onClick={() => {
    //       openModal();
    //     }}
    //   >
    //     {btnTitle}
    //   </p>

    //   {isOpen && typeModal === 'Metal' && (
    //     <MetalView
    //       isOpen={isOpen}
    //       setIsOpen={setIsOpen}
    //       renderTech={renderMetal()}
    //     />
    //   )}

    //   {isOpen && typeModal === 'Polymer' && (
    //     <PolymerView
    //       isOpen={isOpen}
    //       setIsOpen={setIsOpen}
    //       renderTech={renderPolymer()}
    //     />
    //   )}
    // </>
    <div className="d-flex justify-content-center w-100">
      <div className="cmodal_layout mt-12">
        {/* heading */}
        <div className="d-flex justify-content-between">
          <div className="font-16 font-semi-bold">
            What are you looking for?
          </div>
          <img
            src="/assets/CloseIcon.svg"
            alt="close button"
            className="cursor-pointer"
            onClick={() => {
              setSelectedType(null)
              setIsOpen(false)}
            }
          />
        </div>
        {/* body */}
        <div className="d-flex  gap-8">

         { isOpen &&( typeModal === 'Metal'?renderMetal():renderPolymer())}
        </div>
      </div>
    </div>
  );
};
export default CustomModal;
